import { useState } from 'react';

/**
 * Modal do aviso crítico da Setebit.
 *
 * Abre assim que a pessoa entra no painel e só sai quando ela marca como lido —
 * é o que diferencia o aviso "crítico" dos demais, que ficam esperando no sino.
 * Havendo mais de um, mostra um de cada vez, do mais antigo para o mais novo.
 *
 * Não fecha por clique no fundo nem por Esc de propósito: o único jeito de sair
 * é confirmar a leitura, que é o registro que a Setebit precisa ter.
 */
const ModalAvisoCritico = ({ criticos = [], marcarLido }) => {
	const [confirmando, setConfirmando] = useState(false);

	const aviso = criticos[0];

	if (!aviso) return null;

	const confirmar = async () => {
		setConfirmando(true);
		await marcarLido(aviso.id);
		setConfirmando(false);
	};

	return (
		<div style={styles.fundo} role="dialog" aria-modal="true" aria-labelledby="aviso-critico-titulo">
			<div style={styles.caixa}>
				<div style={styles.topo}>
					<span style={styles.tag}>Aviso importante</span>
					{criticos.length > 1 && (
						<span style={styles.contador}>1 de {criticos.length}</span>
					)}
				</div>

				<h4 id="aviso-critico-titulo" style={styles.titulo}>{aviso.titulo}</h4>
				<p style={styles.mensagem}>{aviso.mensagem}</p>

				<div style={styles.rodape}>
					<span style={styles.autor}>
						{aviso.autor ? `Setebit · ${aviso.autor}` : 'Setebit'}
					</span>
					<button type="button" style={styles.botao} onClick={confirmar} disabled={confirmando}>
						{confirmando ? 'Salvando...' : 'Entendi, marcar como lido'}
					</button>
				</div>
			</div>
		</div>
	);
};

const styles = {
	fundo: {
		position: 'fixed', top: 0, right: 0, bottom: 0, left: 0, zIndex: 2000, background: 'rgba(16,24,40,.55)',
		display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
	},
	caixa: {
		background: '#fff', borderRadius: 10, maxWidth: 520, width: '100%',
		padding: '22px 24px', color: '#1f2328', boxShadow: '0 20px 40px rgba(16,24,40,.2)',
	},
	topo: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 },
	tag: {
		background: '#fce8ea', color: '#b32233', borderRadius: 4,
		fontSize: 11, padding: '3px 8px', textTransform: 'uppercase', letterSpacing: .3,
	},
	contador: { fontSize: 12, color: '#98a2b3' },
	titulo: { margin: '0 0 8px', fontSize: 19, fontWeight: 600, color: '#1f2328' },
	mensagem: {
		margin: 0, fontSize: 14.5, lineHeight: 1.55, color: '#344054',
		whiteSpace: 'pre-wrap', maxHeight: '48vh', overflowY: 'auto',
	},
	rodape: {
		display: 'flex', justifyContent: 'space-between', alignItems: 'center',
		gap: 12, marginTop: 22, flexWrap: 'wrap',
	},
	autor: { fontSize: 12, color: '#98a2b3' },
	botao: {
		background: '#1d6fbf', color: '#fff', border: 'none', borderRadius: 6,
		padding: '10px 18px', fontSize: 14, cursor: 'pointer',
	},
};

export default ModalAvisoCritico;
